import React, { Component, useState, useRef  } from 'react';

export default class MarkerIcon extends Component {

  static defaultProps = {};

  constructor(props) {
    super(props);
  }

  render() {

    console.log('p', this.props);
    return (
      <div className="project-marker-position">
        <button className="project-marker">fd
        </button>
      </div>
    );
  }
}
